import { Locale } from '@/providers/Locale/types'

type TextFields = 'next' | 'previous' | 'restart' | 'listSlides' | 'startSlide' | 'nextSlide' | 'previousSlide'

export const i18n: Record<Locale, Record<TextFields, string>> = {
    en: {
        next: 'Next',
        previous: 'Previous',
        restart: 'Start over',
        listSlides: 'List slides',
        startSlide: 'Start Slideshow',
        previousSlide: 'Previous Slide',
        nextSlide: 'Next Slide',
    },
    fr: {
        next: 'Suivant',
        previous: 'Précédent',
        listSlides: 'Liste des diapositives',
        restart: 'Recommencer',
        startSlide: 'Lancer le Diaporama',
        previousSlide: 'Diapositive précédente',
        nextSlide: 'Diapositive suivante',
    },
    es: {
        next: 'Siguiente',
        previous: 'Anterior',
        listSlides: 'Lista de diapositivas',
        restart: 'Empezar de nuevo',
        startSlide: 'Iniciar presentación',
        nextSlide: 'Siguiente diapositiva',
        previousSlide: 'Diapositiva anterior',
    },
    de: {
        next: 'Nächste',
        previous: 'Vorherige',
        listSlides: 'Folien auflisten',
        restart: 'Von vorn anfangen',
        startSlide: 'Diaschau beginnen',
        nextSlide: 'Nächste Folie',
        previousSlide: 'Vorherige Folie',
    },
}
